import { RightOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { H5SubPageShell } from "../../components/common/H5SubPageShell";
import { globalModel } from "../../global/GlobalModel";
import { H5_LEGAL_NAV_SLUGS, H5_LEGAL_TITLES, type H5LegalSlug } from "../../legal/h5LegalContent";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import { useRequireLoginRedirect } from "../../utils/useRequireLoginRedirect";
import "./SpaceMineStyle.css";

export const SpaceMineSettingsPage = observer(() => {
  const { spaceId } = useParams<{ spaceId: string }>();
  const navigate = useNavigate();
  const canView = useRequireLoginRedirect();
  const [loggingOut, setLoggingOut] = useState(false);

  const goLegal = useCallback(
    (slug: H5LegalSlug) => {
      h5NavigateTo(navigate, `/legal/${slug}`);
    },
    [navigate]
  );

  const onLogout = useCallback(() => {
    Modal.confirm({
      title: "退出登录",
      content: "确定退出当前账号？",
      okText: "退出",
      cancelText: "取消",
      centered: true,
      okButtonProps: { loading: loggingOut },
      onOk: async () => {
        setLoggingOut(true);
        try {
          await globalModel.logout();
          const redirect =
            spaceId && /^\d{8}$/.test(spaceId)
              ? encodeURIComponent(`/space/${spaceId}/mine`)
              : encodeURIComponent("/");
          h5NavigateTo(navigate, `/login?redirect=${redirect}`, { replace: true });
        } finally {
          setLoggingOut(false);
        }
      },
    });
  }, [loggingOut, navigate, spaceId]);

  if (!canView || !spaceId) {
    return null;
  }

  return (
    <H5SubPageShell title="系统设置" backTo={`/space/${spaceId}/mine`}>
      <div className="space-mine-settings">
        <section className="space-mine-menu space-mine-settings__section" aria-label="协议与政策">
          {H5_LEGAL_NAV_SLUGS.map((slug) => (
            <button
              key={slug}
              type="button"
              className="space-mine-menu__item"
              onClick={() => goLegal(slug)}
            >
              <span className="space-mine-menu__label">{H5_LEGAL_TITLES[slug]}</span>
              <RightOutlined className="space-mine-menu__arrow" aria-hidden />
            </button>
          ))}
        </section>

        <div className="space-mine-settings__gap" aria-hidden />

        <section className="space-mine-menu space-mine-settings__section" aria-label="账户">
          <button
            type="button"
            className="space-mine-menu__item space-mine-settings__logout"
            onClick={onLogout}
            disabled={loggingOut}
          >
            <span className="space-mine-menu__label">退出登录</span>
          </button>
        </section>
      </div>
    </H5SubPageShell>
  );
});

export default SpaceMineSettingsPage;
